(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('AppCtrl', ['$scope', '$window', '$location', '$q', '$routeParams', '$document', '$timeout', 'User', '$http', 'Config', '$cookies', 'OrganizationContext', 'OrganizationSettings', 'ShareKeyHelper', 'Api', 'Logger', 'ShareUtils', '$rootScope', '$interval', '$uibModal', 'CardQueryResource', 'Analytics', 'wsEventNames', function ($scope, $window, $location, $q, $routeParams, $document, $timeout, User, $http, Config, $cookies, OrganizationContext, OrganizationSettings, ShareKeyHelper, Api, Logger, ShareUtils, $rootScope, $interval, $uibModal, CardQueryResource, Analytics, wsEventNames) {
    // Prevent clickjacking for all but shares,
    // see https://www.owasp.org/index.php/Clickjacking_Defense_Cheat_Sheet
    var isSharePath = $location.path().indexOf("/share/") >= 0;
    if (isSharePath || $window.self === $window.top) {
      var antiClickjack = $window.document.getElementById("ws-anti-cj");
      antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
      $window.top.location = $window.self.location;
    }
    var wsConfig = Config.get();

    // If SSL is enabled, use it
    if (wsConfig.sslEnabled === true && $window.location.protocol !== "https:") {
      $window.location.protocol = "https";
      return;
    }
    var user = User.get(),
      idleCheck,
      idleTimeout = 1000 * 60 * 60;
    var initializeAnalyticsAndHelp = function initializeAnalyticsAndHelp(issueLoginEvent) {
      Analytics.initialize(user).then(function () {
        if (issueLoginEvent) {
          Analytics.sendEvent('Logged In', {
            category: 'Authentication',
            label: "Watershed LRS",
            statement: Analytics.getLoggedIn()
          });
        }
      });
    };
    var sendLoggedOutEvent = _.once(function () {
      Analytics.sendEvent('Logged Out', {
        category: 'Authentication',
        label: "Watershed LRS",
        statement: Analytics.getLoggedOut()
      }, true);
    });
    var handleOrgChange = function handleOrgChange(org) {
      if (!org) {
        return;
      }
      OrganizationSettings.getForOrganization(org.id).then(function (settings) {
        if (settings && settings.idleTimeoutMinutes && settings.idleTimeoutMinutes > 0) {
          idleTimeout = 1000 * 60 * settings.idleTimeoutMinutes;
        }
      });
    };
    $scope.logout = function logout(reason, autoLogout) {
      function appendParam(url, name, value) {
        if (value === null || value === undefined) {
          return url;
        } else {
          var separator = url.indexOf("?") === -1 ? "?" : "&";
          return url + separator + name + "=" + encodeURIComponent(value);
        }
      }
      var redirectPromises = [];
      var redirectUrl = wsConfig.outsideUrl;
      var session = User.get();
      if (session && session.user && session.user.username) {
        var organization = session.organization;
        var username = session.user.username;

        // If this is a SAML user session...
        var isSso = username.includes('http') && username.includes('|');
        if (isSso && organization) {
          // Make sure we add the org context to the login redirect
          if (organization.urlName) {
            redirectUrl = appendParam(redirectUrl, "org", organization.urlName);
          }

          // But also check the settings, to see if there's a custom logout redirect URL
          redirectPromises.push(OrganizationSettings.getForOrganization(organization.id).then(function (settings) {
            if (!autoLogout && settings && settings.logoutRedirectUrl) {
              redirectUrl = settings.logoutRedirectUrl;
            }
          }));
        }
      } else {
        // If the location has org=urlname, use that same parameter in the redirect
        var match = new RegExp("[&?]org=([^&?]*)", "g").exec($window.location);
        if (match && match.length && match.length === 2) {
          redirectUrl = appendParam(redirectUrl, "org", match[1]);

          // Or else if it's a report, with a card ID, let's fetch a token we can
          // use to identify the organization it belongs to, so we can include this
          // info in the login redirect.
        } else {
          match = new RegExp("(activity|bar|card-group|correlation|dashboard|interactions|leaderboard|line|metric|person|program|range|scatter|spider)/(\\d+)", "g").exec($window.location);
          if (match && match.length && match.length === 3) {
            var resource = match[1] === "dashboard" ? "card-groups" : "cards";
            var url = "".concat(wsConfig.apiUrl, "/").concat(resource, "/").concat(match[2], "/url-nt");
            redirectPromises.push($http.get(url).then(function (response) {
              redirectUrl = appendParam(redirectUrl, "org", response.data.value);
            }));
          }
        }
      }

      // If sso user also append this, which tells the login page to NOT auto-login but to
      // instead present a login button without the user/pass fields
      if (User.get().user) {
        var _username = User.get().user.username;
        var _isSso = _username.includes('http') && _username.includes('|');
        if (_isSso) {
          redirectUrl = appendParam(redirectUrl, "samlLogout", "true");
        }
      }
      if (reason) {
        if (reason === "expired") {
          redirectUrl += "#/expired";
        } else {
          redirectUrl = appendParam(redirectUrl, "reason", reason);
        }
      }
      if (!autoLogout && user.organization) {
        sendLoggedOutEvent();
      }
      if (idleCheck) {
        $interval.cancel(idleCheck);
      }
      $q.all(redirectPromises).then(function () {
        $http.delete(wsConfig.apiUrl + "/login").then(function () {
          User.clear();
          OrganizationContext.clear();
          $scope.authenticated = false;
          $window.location.href = redirectUrl;
        });
      });
    };

    // Make the config widely available to controllers (and more so, views)
    $scope.wsConfig = wsConfig;

    // Note if the nav has been hidden
    $scope.$on("nav:change", function (evt, activeView) {
      $scope.navHidden = activeView === 'hide';
      $scope.outsideFacade = activeView === 'outsideFacade';
    });

    // Check if this share is an embed by checking for iFrame
    if (ShareKeyHelper.hasShareKey()) {
      $scope.shareView = true;
      try {
        $scope.embedView = window.self !== window.top;
      } catch (e) {
        $scope.embedView = false;
      }
    }
    if (($scope.embedView || $scope.shareView) && wsConfig.hideBranding) {
      $scope.hideBranding = true;
    }

    //If user not authenticated and we're not in a sharing context, execute logout
    if (user.unauthenticated) {
      if ($scope.shareView) {
        $scope.authenticated = false;
      } else {
        //Save where the user was trying to go, so we can redirect
        //them there after login (see orgs.js)
        $cookies.put('destination', $window.location.toString());
        $scope.logout(null, true);
        return;
      }
    } else {
      $scope.authenticated = true;
      handleOrgChange(user.organization);

      // When starting up a new session, we need to see if there was
      // a prior unclosed session that is now stale. To do that, we check for
      // the last activity from any other session, and only set to the current
      // time if we don't find one.
      var lastUserActivity = User.getGlobalLastActivity() || Date.now();
      var logoutIfSessionTimedOut = function logoutIfSessionTimedOut(initialCheck) {
        // check against last activity from all tabs / prior sessions
        // and save away current date from this session if it's the latest
        var globalLastUserActivity = User.getGlobalLastActivity();
        if (globalLastUserActivity >= lastUserActivity) {
          lastUserActivity = globalLastUserActivity;
        } else {
          User.setGlobalLastActivity(lastUserActivity);
        }

        // We need to fetch any customized idle timeout synchronously here to make
        // sure the initial check uses the value if specified.
        if (initialCheck) {
          var orgSettings = OrganizationSettings.getSettingsSync();
          if (orgSettings && orgSettings.idleTimeoutMinutes) {
            idleTimeout = orgSettings.idleTimeoutMinutes * 60 * 1000;
          }
        }

        // log out after no activity for the idle timeout period
        if (Date.now() - lastUserActivity > idleTimeout) {
          $scope.logout("unauthorized");
        }
      };

      // Do an initial session expiry check right away, in case there is an
      // expired prior session.
      logoutIfSessionTimedOut(true);

      // Otherwise, logging in counts as latest activity
      lastUserActivity = Date.now();

      // And let's setup the ongoing check to see if the user has gone idle
      idleCheck = $interval(function () {
        return logoutIfSessionTimedOut(false);
      }, 60 * 1000);
      $rootScope.$on('$routeChangeStart', function (evt, next, current) {
        lastUserActivity = Date.now();
        if (current && current.params && (current.params.boardId || current.params.parentGroupId)) {
          CardQueryResource.cancelAllOutstanding();
        }
        if (next.params.cardId && next.params.cardId !== 'preview') {
          Analytics.cardViewed(next.params.cardId, next.$$route.originalPath.replace(/(\/|:cardId)/g, ""));
        }
        if (next.params.boardId) {
          Analytics.dashboardViewed(next.params.boardId);
        }
        if (next.$$route && next.$$route.originalPath === '/essentials') {
          Analytics.essentialsViewed(next.params.demo);
        }
      });
      $rootScope.$on("update-last-user-activity", function () {
        lastUserActivity = Date.now();
      });
      $document.on('click', function () {
        lastUserActivity = Date.now();
      });
      $document.on('keypress', function () {
        lastUserActivity = Date.now();
      });

      // Fire this off to make sure nav updates no matter what page we're
      // starting on (when user refreshes etc)
      $timeout(function () {
        $rootScope.$broadcast(wsEventNames.nav.update);
      }, 100);
    }
    $scope.userId = user.user ? user.user.id : null;

    // Update customCssUrl according to custom CSS fromt he org, if set
    if (user.organization && user.organization.lessUrl && wsConfig.buildInformation && wsConfig.buildInformation.commitId) {
      $scope.customCssUrl = Api.url('/css/' + wsConfig.buildInformation.commitId);
    } else if ($scope.shareView && wsConfig.buildInformation && wsConfig.buildInformation.commitId) {
      ShareUtils.getShare().then(function (share) {
        if (share !== null) {
          $scope.customCssUrl = Api.url('/css/' + wsConfig.buildInformation.commitId + '?shareKey=' + share.key);
          if (share.cssUrl) {
            $rootScope.customCardCssUrl = share.cssUrl;
            $scope.customCardCssUrl = share.cssUrl;
          }
        }
      });
    } else {
      $scope.customCssUrl = null;
    }

    // When a user picks a new org, set the org metadata in the analytics account
    $scope.$on("organization-selected", function (event, org) {
      if (org.lessUrl) {
        $scope.customCssUrl = Api.url('/css/' + wsConfig.buildInformation.commitId);
      } else {
        $scope.customCssUrl = null;
      }
      handleOrgChange(org);
      initializeAnalyticsAndHelp(true);
    });
    if (!$scope.embedView) {
      //If no organization has been selected, send them to org selection (unless on it or unauthenticated)
      if ($scope.authenticated && typeof user.organization === "undefined" && $location.path() !== "/orgs") {
        $location.path("/orgs");
      }
    } else {
      if ($scope.authenticated) {
        initializeAnalyticsAndHelp(false);
      }
    }

    // If we catch unauthenticated request error, send them to sign in
    $scope.$on("unauthorized-request", function () {
      var shareKey = ShareKeyHelper.getShareKey();
      if (!shareKey) {
        User.clear();
        $scope.authenticated = false;
        $scope.logout("unauthorized", true);
      } else {
        Logger.error("Hit unauthorized error in share context, for share " + shareKey);
      }
    });
    $rootScope.$on('demo-tour', function (evt, tourCfg) {
      $uibModal.open({
        templateUrl: "modules/app/essentials/demoTourModal.html",
        controller: "EssentialsDemoTourModalCtrl",
        windowClass: 'demo-tour-modal',
        backdrop: 'static',
        scope: $scope,
        resolve: {
          tourConfig: tourCfg
        }
      });
    });
  }]);
})();
